import { render, staticRenderFns } from "./PointsExchangeRecords.vue?vue&type=template&id=33a89e0f&"
import script from "./PointsExchangeRecords.vue?vue&type=script&lang=js&"
export * from "./PointsExchangeRecords.vue?vue&type=script&lang=js&"
import style0 from "./PointsExchangeRecords.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports